import { StyleSheet } from "aphrodite";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  accentColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";

interface IStyle {
  starRating: any;
  starPositive: any;
  iconBlock: any;
  num: any;
  block: any;
}

export const StarRatingStyle: IStyle = StyleSheet.create({
  starRating: {
    color: accentColor.starColor,
    overflow: "hidden",
    margin: 0,
    lineHeight: 1,
  },
  starPositive: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  iconBlock: {
    position: "relative",
    display: "inline-block",
    verticalAlign: "middle",
  },
  num: {
    fontSize: fontSize.caption,
    lineHeight: lineHeight.noSpace,
    color: textColor.secondaryDarkColor,
    display: "inline-block",
    verticalAlign: "middle",
    padding: `0 0 0 ${space.atom0_5x}`,
    letterSpacing: "0.05em",
  },
  block: {
    position: "relative",
    fontSize: fontSize.body,
    padding: space.atom,
    lineHeight: 0.1,
  },
});
